import { RootState } from './../core/store';
import { Locale } from './userPreferences';
import { MessageFormatElement } from 'react-intl';
import { AppDispatch } from '../core/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type Message = Record<string, string> | Record<string, MessageFormatElement[]> | undefined;

interface MessagesReducerState {
  messages?: Message;
}

const initialState: MessagesReducerState = {};

const i18nSlice = createSlice({
  name: 'i18nMessages',
  initialState,
  reducers: {
    setMessages: (state: MessagesReducerState, action: PayloadAction<Message>) => {
      state.messages = action.payload;
    },
  },
});

export default i18nSlice.reducer;
const { setMessages } = i18nSlice.actions;
export const messagesSelector = (state: RootState) => state.i18n.messages;

const messageLoaders: Record<Locale, () => Promise<{ default: Message }>> = {
  pt: () => import('../i18n/messages/pt.json'),
  es: () => import('../i18n/messages/es.json'),
  en: () => import('../i18n/messages/en.json'),
  fr: () => import('../i18n/messages/fr.json'),
};

export const loadMessages = (locale: Locale) => async (dispatch: AppDispatch) => {
  const load = messageLoaders[locale] ?? messageLoaders.pt;
  const module = await load();

  dispatch(setMessages(module.default));
};
